import React from 'react';
import clsx from 'clsx';
import { Card, Container, CssBaseline, Grid } from '@material-ui/core';
import AppBarComponent from '../layout/AppBar';
import Scrollbar from 'react-scrollbars-custom';
import DevicesTable from './DevicesTable';
import { useStyles } from '../styles/useStyles';
import DeviceUsersTable from './fingers-management/DeviceUsersTable';

export default function Devices(props) {
    const [loc] = React.useState(() => {
        const locData = localStorage.getItem('loc');
        return locData ? JSON.parse(locData).id : '';
    });
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <CssBaseline />
            <AppBarComponent />
            <main className={classes.content}>
                <Scrollbar
                    id="RSC-Example"
                    style={{ width: '100%', height: '100%' }}
                >
                    <div className={classes.appBarSpacer} />
                    <Container maxWidth={false} className={classes.container}>
                        <Grid container spacing={3} alignItems="stretch">
                            <Grid
                                item
                                xs={12}
                                lg={6}
                                style={{ display: 'flex' }}
                            >
                                <Card
                                    className={clsx(classes.card)}
                                    style={{ flex: 1, width: '100%' }}
                                >
                                    <DeviceUsersTable
                                        className={classes.devicesTable}
                                    />
                                </Card>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                lg={6}
                                style={{ display: 'flex' }}
                            >
                                <Card
                                    className={clsx(
                                        classes.card,
                                        classes.devicesPanelCard
                                    )}
                                >
                                    <DevicesTable
                                        className={classes.devicesPanelTable}
                                    />
                                </Card>
                            </Grid>
                        </Grid>
                    </Container>
                </Scrollbar>
            </main>
        </div>
    );
}
